export type Duration = "year" | "week" | "day" | "hour" | "minute" | "second";
export type DurationFormat = "short" | "abbrev" | "long";

const pluralizeDuration = (value: number, duration: Duration): string => {
  return [value, value === 1 ? duration : `${duration}s`].join(" ");
};

const formatDurationString = (value: number, duration: Duration, format: DurationFormat = "short"): string => {
  const abbrev: Record<Duration, string> = {
    year: "yr",
    week: "wk",
    day: "d",
    hour: "hrs",
    minute: "min",
    second: "s",
  };

  switch (format) {
  case "short":
    return `${value}${duration.charAt(0)}`;
  case "abbrev":
    return `${value} ${abbrev[duration]}`;
  case "long":
    return pluralizeDuration(value, duration);
  }
};

export const formatDuration = (durationInSeconds: number, format: DurationFormat = "short"): string => {
  if (durationInSeconds < 60) return formatDurationString(durationInSeconds, "second", format);

  const durationInMinutes = Math.floor(durationInSeconds / 60);
  const hours = Math.floor(durationInMinutes / 60);
  const minutes = durationInMinutes % 60;

  if (hours === 0) return formatDurationString(minutes, "minute", format);
  if (minutes === 0) return formatDurationString(hours, "hour", format);

  switch (format) {
  case "long":
    return [pluralizeDuration(hours, "hour"), pluralizeDuration(minutes, "minute")].join(" and ");
  default:
    return `${hours}h ${minutes}m`;
  }
};
